import React from 'react';
import ImageLoader from '../images/ImageLoader';
import Overlay from '../modal/Overlay';
import { Button } from 'react-bootstrap';

var BonusGameOverlay = function BonusGameOverlay(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      hide = props.hide;
  var LogoImage = model.LogoImage,
      Image = model.Image,
      Description = model.Description,
      BackButtonLabel = model.BackButtonLabel;
  return /*#__PURE__*/React.createElement(Overlay, {
    hide: hide,
    show: show,
    className: 'overlay--bonus-game',
    size: "sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-bonus-game-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-overlay__logo-image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: LogoImage,
    type: 'product',
    className: "cb-bonus-game-overlay__logo-image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-overlay__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-bonus-game-overlay__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-overlay__description-container'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'cb-bonus-game-overlay__description'
  }, Description.value)), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-overlay__back-button-container'
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-bonus-game-overlay__back-button",
    onClick: hide
  }, BackButtonLabel.value))));
};

export default BonusGameOverlay;